import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { InstitutionRankingUserListResponseData } from "../../types/institution-ranking";

export const getData =
  async (): Promise<InstitutionRankingUserListResponseData> => {
    const { data } = await api.get(`/institution-ranking-user`);

    return data;
  };

export const useInstitutionRankingUser =
  (): QueryObserverBaseResult<InstitutionRankingUserListResponseData> => {
    const { data, ...props } = useQuery(
      queryKeys.institutionRankingUser(),
      () => getData(),
    );
    return { data, ...props };
  };
